import React from "react";
import { FaPhone, FaEnvelope, FaWhatsapp } from "react-icons/fa";
import "./StickyBanner.scss";

const StickyBanner = () => {
  return (
    <div className="sticky-top-banner">
      <div className="container">
        <div className="sticky-top-banner__content">
          <div className="sticky-top-banner__left">
            <div className="sticky-top-banner__item">
              <FaPhone className="sticky-top-banner__icon" />
              <a href="tel:+919626188801">(+91) 9626188801</a>
            </div>
            <div className="sticky-top-banner__item">
              <FaPhone className="sticky-top-banner__icon" />
              <a href="tel:+919940907979">(+91) 9940907979</a>
            </div>
            <div className="sticky-top-banner__item">
              <FaEnvelope className="sticky-top-banner__icon" />
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=sales@machtech.co.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                sales@machtech.co.in
              </a>
            </div>
            <div className="sticky-top-banner__item">
              <FaEnvelope className="sticky-top-banner__icon" />
              <a
                href="mailto:machtechnologies@outlook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                machtechnologies@outlook.com
              </a>
            </div>
          </div>
          <div className="sticky-top-banner__social">
            <span className="sticky-top-banner__social-label">WhatsApp:</span>
            <a
              href="https://wa.me/919626188801"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyBanner;
